export default __webpack_public_path__ + "static/media/pictogramBeaconModem64.3de6aaaf.svg";